import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import NextStep from '../elements/NextStep';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { __, __n } from 'i18n-for-browser';

import ListButton from '../elements/ListButton';
import EconomyTotal from "../elements/EconomyTotal";
import EconomyEarned from "../elements/EconomyEarned";

import Defines from '../../Defines';
import {
  getUnreadWinstGlobas,
  getUnreadVerliesGlobas,
  renderMinistryFeedbackList,
  getEconomieFeedback,
  getEconomieFeedbackFormatted,
  unreadCount,
  getPolicyChoiceFeedback,
  getLowMinistryFeedbackLink,
  getPolicyChoiceTotalPoints, checkRead,
} from '../../helpers/feedbackHelpers';
import {
  getTotalCosts,
  choicesToMake,
  getTitle,
  getIcon,
  groupByProblem,
  getOplossingTitle
} from '../../helpers/policyChoiceHelper';
import { getOverviewData } from '../../helpers/ministriesHelper';
import DifficultyAwareComponent from "../DifficultyAwareComponent";
import {
  calculateSavingsAndLoans, calculateBudgetBASIC, getMinistryGlobasSpent
} from '../../helpers/calculationsHelper';

import Team from '../../assets/img/icons/economy/team.svg';
import Economy from '../../assets/img/icons/economy/economy.svg';
import UpGlobas from '../../assets/img/icons/economy/up-globas.svg';
import MinGlobas from '../../assets/img/icons/economy/min-globas.svg';
import SparenBank from '../../assets/img/icons/sparen_bank.svg';
import BeleidskeuzeL from '../../assets/img/icons/beleidskeuze_L.svg';
import PopUp from '../elements/PopUp';
import Warning from "../../assets/img/icons/warning.svg";
import PopupTitle from "../elements/PopupTitle";
import PolicyChoiceLaag from "../elements/PolicyChoiceLaag";
import MinistryFeedbackStatus from "../elements/StepThree/MinistryFeedbackStatus";
import UpMinGlobas from "../../assets/img/icons/economy/up-min-globas.svg";

/**
 * Import assets
 */
class Ministries extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      showOverview: false,
      showWarning: '',
    };
  }

  componentDidMount() {
    const { gameState } = this.props;

    if (gameState.currentStep === 3) {
      document.querySelector('.sidebar').classList.add('step3');
      document.querySelector('.main').classList.add('step3');
    } else {
      document.querySelector('.sidebar').classList.remove('step3');
      document.querySelector('.main').classList.remove('step3');
    }
  }

  toggleOverviewPopUp = () => {
    this.setState({
      showOverview: !this.state.showOverview,
    })
  };

  renderLaag() {
    const { gameState, gameStateInput, feedback, policyChoice, group } = this.props;
    const { prevRoundSum } = gameState;
    const { ministerieGlobaVerdeling, policyChoices, ministryCollaborations } = gameStateInput.myState;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];
    const { prevRoundFeedbackData } = feedback;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetBASIC(gameState, policyChoices, ministerieGlobaVerdeling, savingsAndLoans, policyChoice);
    if (!prevRoundSum) return null;
    const { OneTimeEffect } = prevRoundSum;

    const filteredPolicyChoices = groupByProblem(policyChoice);

    const unreadWinstGlobas = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    const unreadVerliesGlobas = getUnreadVerliesGlobas(prevRoundFeedbackData).length;

    const { params } = this.props.match;
    const isFeedback = !!(params.feedbackIdentifier);
    const isStartSituation = (group.Rounds.length === 2);

    let currentMin = params.ministryId || params.economyType || params.id || params.type;

    if (params.effect === 'loss') { currentMin = 'loss' }
    if (params.effect === 'profit') { currentMin = 'profit' }

    let policyLink = '';
    if (this.props.match.path.includes('beleidskeuzes')) {
      policyLink = '/';
    } else {
      policyLink = '/beleidskeuzes'
    }
    const { remainingSavingsPoints, remainingProfitLossPoints } = gameState.gameStateSum;
    return (
      <div>
        <div className='container ministries-list'>
          {gameState.currentStep === 3 ? null : (
            <div className='economy-list'>
              <PopupTitle popupId={'dlgvteconomie'} tag={'h3'} />
              <Link to={currentMin === 'total' ? '/' : '/economy/total'}>
                <ListButton
                  className={`total-economy-list-button ${currentMin === 'total' || currentMin === 'earned' ? 'show' : ''}`}
                  bgColor='darkblue'
                  feedbackCount={(unreadWinstGlobas + unreadVerliesGlobas)}
                  title={__("sim_totalglobas")}
                  icon={Economy}
                  globas={gameState.totalEconomy}
                  points={currentRoundGameState.earnedPoints}
                />
              </Link>
              {currentMin === 'total' || currentMin === 'earned' || currentMin === 'profit' || currentMin === 'loss' ? (
                <div>
                  <Link to={currentMin === 'earned' ? '/economy/total' : '/economy/earned'}>
                    <ListButton bgColor='blue' title={__("sim_earnedglobas")} icon={Team} globas={currentRound === 5 ? '-' : currentRoundGameState.earnedGlobas} points={currentRound === 5 ? '-' : currentRoundGameState.earnedPoints} />
                  </Link>
                  {!(currentRound === 5) && currentMin === 'earned' ? (
                    <div className={'economy-details'}>
                      <EconomyEarned />
                    </div>
                  ) : null}

                  <div className={'desktop-ministry-list'}>
                    <Link to={currentMin === 'profit' ? '/economy/total' : '/ministries/overview/basic/profit'}>
                      <ListButton bgColor='blue' title={__('sim_winstglobas')} className={(currentMin === 'profit' ? 'show' : '')} icon={UpGlobas} feedbackCount={unreadWinstGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.WG === 0 ? 0 : '+ ' + OneTimeEffect.WG)} />
                    </Link>
                  </div>

                  <div className={'desktop-ministry-list'}>
                    <Link to={currentMin === 'loss' ? '/economy/total' : '/ministries/overview/basic/loss'}>
                      <ListButton bgColor='blue' title={__('sim_verliesglobas')} className={(currentMin === 'loss' ? 'show' : '')} icon={MinGlobas} feedbackCount={unreadVerliesGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.VG === 0 ? 0 : '- ' + -OneTimeEffect.VG)} />
                    </Link>
                  </div>
                </div>
              ) : null}

            </div>
          )}

          {gameState.currentStep === 1 && gameState.currentRound <= 1 ? null : (
            this.props.project.minPolicyChoices > 0 ? (
              <div className='economy-list'>
                <PopupTitle popupId={'dlgvtstap3beleidskeuzes'} tag={'h3'} />
                <Link to={policyLink}>
                  <ListButton
                    bgColor='darkblue'
                    title={__n('sim_beleidskeuze', 0)}
                    icon={BeleidskeuzeL}
                    className={`beleidskeuze-listbutton-laag ${this.props.match.path.includes('beleidskeuzes') ? 'show' : ''}`}
                    feedbackCount={
                      gameState.currentStep === 3
                        ? choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices)
                        : unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)
                    }
                    arrow={true}
                    redNotification={gameState.currentStep === 3}
                    points={gameState.currentStep === 1 ? getPolicyChoiceTotalPoints(feedback.prevRoundFeedbackData) : false}
                    globas={gameState.currentStep === 3 ? getTotalCosts(gameStateInput.myState.policyChoices, policyChoice) : undefined}
                  />
                </Link>

                {this.props.match.path.includes('beleidskeuzes') ?
                  <div className={'low-policy'}>
                    {gameState.currentStep === 3 ? filteredPolicyChoices.map((pc, i) => {
                      if (i < this.props.project.minPolicyChoices) {
                        return (
                          <Link to={'/beleidskeuzes/' + i} key={i}>
                            <PolicyChoiceLaag
                              key={i}
                              problem={pc}
                              highlight={parseInt(this.props.match.params.beleidskeuze, 10) === i}
                              spendableGlobas={globas}
                              listView={true}
                            />
                          </Link>
                        )
                      } else {
                        return false;
                      }
                    }) : (
                      <div className="feedback-list">
                        {getPolicyChoiceFeedback(feedback.prevRoundFeedbackData).map((feedback, i) => {
                          let title;
                          if (feedback.oplossing_code) {
                            title = getOplossingTitle(feedback, gameState.language);
                          } else {
                            title = getTitle(feedback, gameState.language);
                          }
                          return (
                            <div className={'feedback-container-low'} key={i}>
                              <ListButton
                                feedbackCount={checkRead(feedback) ? 0 : 1}
                                bgColor={feedback.kleur_balk}
                                title={title}
                                arrow={true}
                                className={this.props.match.params.feedbackIdentifier === feedback.omschrijving ? 'show' : ''}
                                feedback={true}
                                thumbnail={getIcon(feedback)}
                                points={feedback.puntenscore}
                                onClick={() => {
                                  this.props.history.push(`/beleidskeuzes/beleidskeuze/${feedback.omschrijving}`);
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div> : ''
                }
              </div>
            ) : null
          )}

          <div className='ministry-list'>
            <PopupTitle popupId={'dlgvtministeries'} tag={'h3'} />
            {Defines['basic'].ministries.map(min => (
              <div className={currentMin === min.toLowerCase() ? 'desktop-ministry-list show show--no-margin' : 'desktop-ministry-list'} key={min}>
                <Link className={'min-link'} to={
                  (currentMin === min.toLowerCase() ?
                    '/'
                    :
                    (gameState.currentStep === 3 ?
                      '/ministries/budget/' + min.toLowerCase()
                      :
                      (getLowMinistryFeedbackLink(this.props.feedback.prevRoundFeedbackData, min, this.props.gameState, this.props.gameStateInput).length > 0 ?
                        getLowMinistryFeedbackLink(this.props.feedback.prevRoundFeedbackData, min, this.props.gameState, this.props.gameStateInput)[0]
                        :
                        '/ministries/' + min.toLowerCase()
                      )
                    )
                  )
                }>
                  <ListButton
                    ministry={min}
                    title={__(min)}
                    hideOverflow={currentMin === min.toLowerCase()}
                    icon={Defines.icons[min]}
                    arrow={true}
                    points={gameState.currentStep === 1 ? (prevRoundSum ? prevRoundSum[`${min}_points`] + '' : '...') : false}
                    global={Defines.i18nMinistries.includes(min)}
                    globas={getMinistryGlobasSpent(gameStateInput.myState.ministerieGlobaVerdeling, min, gameState.currentStep)}
                    collaboration={gameState.currentStep === 1 ? ministryCollaborations[min] : ministerieGlobaVerdeling[min + 'SW']}
                  />
                </Link>
                {currentMin === min.toLowerCase() ? (
                  <div className={'feedback-list'}>
                    {gameState.currentStep === 3 ? (
                      <MinistryFeedbackStatus ministry={min} showFeedback={isFeedback} />
                    ) : null}
                  </div>
                ) : null}
              </div>
            ))}
          </div>

          {remainingSavingsPoints > 0 || remainingProfitLossPoints !== 0 && !gameState.history ? (
            <div className="overige-list">
              <PopupTitle popupId={'mhgvtoverzicht_overige'} tag={'h3'} />
              {remainingSavingsPoints > 0 ?
                <ListButton
                  title={__('sim_overige_spaargeld')}
                  icon={SparenBank}
                  arrow={true}
                  points={remainingSavingsPoints}
                />
                : null}
              {remainingProfitLossPoints !== 0 ?
                <ListButton
                  title={__('sim_overige_wgvg')}
                  icon={UpMinGlobas}
                  arrow={true}
                  points={remainingProfitLossPoints}
                />
                : null}
            </div>
          ) : null}

          {this.props.gameState.roundData.state === 'SIMULATION_SPENDING' && this.props.gameStateInput.myState.SIMULATION_SPENDING !== 'PROCESSED' ? (
            <div className="buttonWrap">
              <button onClick={this.toggleOverviewPopUp} className={'button button--blue'}><span>{__('sim_overzicht_verdeling')}</span></button>
              {this.state.showOverview ?
                <PopUp
                  interactive
                  showPopUp={true}
                  closePopUpCross={true}
                  closePopUpClick={this.toggleOverviewPopUp}
                >{getOverviewData(this.props)}</PopUp> : null
              }
            </div>
          ) : null}
        </div>
        {this.state.showWarning.length ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            description={__(this.state.showWarning)}
            closePopUpClick={() => this.setState({ showWarning: '' })}
          />
        ) : null}
        <NextStep />
      </div>
    );
  }

  renderHoog() {
    const { gameState, gameStateInput, feedback, group } = this.props;
    const { prevRoundSum } = gameState;
    const { ministerieGlobaVerdeling } = gameStateInput.myState;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];
    const { prevRoundFeedbackData } = feedback;
    if (!prevRoundSum) return null;
    const { OneTimeEffect } = prevRoundSum;
    const policyChoicesArray = Object.values(gameStateInput.myState.policyChoices);

    const winstGlobasFeedbackCount = getEconomieFeedback(prevRoundFeedbackData, 'profit').length;
    const verliesGlobasFeedbackCount = getEconomieFeedback(prevRoundFeedbackData, 'loss').length;

    const unreadWinstGlobas = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    const unreadVerliesGlobas = getUnreadVerliesGlobas(prevRoundFeedbackData).length;
    const { params } = this.props.match;
    const isFeedback = !!(params.feedbackIdentifier);
    const isStartSituation = (group.Rounds.length === 2);

    let currentMin = params.ministryId || params.economyType || params.id || params.type;

    if (params.effect === 'loss') { currentMin = 'loss' }
    if (params.effect === 'profit') { currentMin = 'profit' }
    const { remainingSavingsPoints, remainingProfitLossPoints } = gameState.gameStateSum;
    return (
      <div>
        <div className='container ministries-list'>
          {gameState.currentStep === 3 ? null : (
            <div className='economy-list'>
              <PopupTitle popupId={'dhgvteconomie'} tag={'h3'} />
              <Link to={currentMin === 'total' ? '/' : '/economy/total'}>
                <ListButton className={'total-economy-list-button'} bgColor='darkblue' title={__('sim_totalglobas')} icon={Economy} globas={gameState.totalEconomy} points={currentRoundGameState.earnedPoints} />
              </Link>
              {currentMin === 'total' ? (
                <div className={'economy-details'}>
                  <EconomyTotal />
                </div>
              ) : null}
              <Link to={currentMin === 'earned' ? '/' : '/economy/earned'}>
                <ListButton bgColor='blue' title={__('sim_earnedglobas')} icon={Team} globas={currentRound === 5 ? '-' : currentRoundGameState.earnedGlobas} points={currentRound === 5 ? '-' : currentRoundGameState.earnedPoints} />
              </Link>
              {!(currentRound === 5) && currentMin === 'earned' ? (
                <div className={'economy-details'}>
                  <EconomyEarned />
                </div>
              ) : null}

              <div className={currentMin === 'profit' && winstGlobasFeedbackCount > 0 ? 'desktop-ministry-list show' : 'desktop-ministry-list'}>
                <Link to={currentMin === 'profit' ? '/' : '/ministries/overview/profit'}>
                  <ListButton bgColor='blue' title={__('sim_winstglobas')} className={(currentMin === 'profit' ? 'show' : '')} icon={UpGlobas} feedbackCount={unreadWinstGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.WG === 0 ? 0 : '+ ' + OneTimeEffect.WG)} />
                </Link>
                <div className={'feedback-list'}>
                  {getEconomieFeedbackFormatted(this.props.feedback.prevRoundFeedbackData, 'profit', gameState)}
                </div>
              </div>

              <div className={currentMin === 'loss' && verliesGlobasFeedbackCount > 0 ? 'desktop-ministry-list show' : 'desktop-ministry-list'}>
                <Link to={currentMin === 'loss' ? '/' : '/ministries/overview/loss'}>
                  <ListButton bgColor='blue' title={__('sim_verliesglobas')} className={(currentMin === 'loss' ? 'show' : '')} icon={MinGlobas} feedbackCount={unreadVerliesGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.VG === 0 ? 0 : '- ' + -OneTimeEffect.VG)} />
                </Link>
                <div className={'feedback-list'}>
                  {getEconomieFeedbackFormatted(this.props.feedback.prevRoundFeedbackData, 'loss', gameState)}
                </div>
              </div>

            </div>
          )}
          <div className='ministry-list'>
            <PopupTitle popupId={'dhgvtministeries'} tag={'h3'} />
            {Defines['pro'].ministries.map(min => (
              <div className={currentMin === min.toLowerCase() ? 'desktop-ministry-list show' : 'desktop-ministry-list'} key={min}>
                <Link className={'min-link'} to={currentMin === min.toLowerCase() ? '/' : (`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`)}>
                  <ListButton
                    ministry={min}
                    title={__(min)}
                    popupId={(currentMin === min.toLowerCase() && gameState.currentStep !== 3 ? Defines.ministryPopupIds.pro[min] : false)}
                    icon={Defines.icons[min]}
                    arrow={true}
                    stars={Defines.ministeryStars[min]}
                    hideOverflow={currentMin === min.toLowerCase()}
                    points={gameState.currentStep === 1 ? (prevRoundSum ? prevRoundSum[`${min}_points`] + '' : 0) : false}
                    globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, min, gameState.currentStep, policyChoicesArray)}
                    global={Defines.i18nMinistries.includes(min)}
                    budgetSet={ministerieGlobaVerdeling[min] && gameState.currentStep > 1}
                    policySet={policyChoicesArray.find(choice => choice.ministry === min && choice.selected) && gameState.currentStep > 1}
                    hideDisaster={(currentMin === min.toLowerCase())}
                  />
                </Link>
                {currentMin === min.toLowerCase() ? (
                  <div className={'feedback-list'}>
                    {gameState.currentStep === 3 ? (
                      <MinistryFeedbackStatus ministry={min} showFeedback={isFeedback} />
                    ) : (
                      <Fragment>
                        {renderMinistryFeedbackList(this.props.feedback.prevRoundFeedbackData, min, this.props.gameState, this.props.gameStateInput, this.props.match.params.feedbackIdentifier)}
                      </Fragment>
                    )}
                  </div>
                ) : null}
              </div>
            ))}
          </div>

          {remainingSavingsPoints > 0 || remainingProfitLossPoints !== 0 && !gameState.history ? (
            <div className="overige-list">
              <PopupTitle popupId={'mhgvtoverzicht_overige'} tag={'h3'} />
              {remainingSavingsPoints > 0 ?
                <ListButton
                  title={__('sim_overige_spaargeld')}
                  icon={SparenBank}
                  arrow={true}
                  points={remainingSavingsPoints}
                />
                : null}
              {remainingProfitLossPoints !== 0 ?
                <ListButton
                  title={__('sim_overige_wgvg')}
                  icon={UpMinGlobas}
                  arrow={true}
                  points={remainingProfitLossPoints}
                />
                : null}
            </div>
          ) : null}

          {this.props.gameState.roundData.state === 'SIMULATION_SPENDING' && this.props.gameStateInput.myState.SIMULATION_SPENDING !== 'PROCESSED' ? (
            <div className="buttonWrap">
              <button onClick={this.toggleOverviewPopUp} className={'button button--blue'}><span>{__('sim_overzicht_verdeling')}</span></button>
              {this.state.showOverview ?
                <PopUp
                  interactive
                  showPopUp={true}
                  closePopUpCross={true}
                  closePopUpClick={this.toggleOverviewPopUp}
                >{getOverviewData(this.props)}</PopUp>
                : null}
            </div>
          ) : null}
        </div>

        <NextStep />
      </div>
    );
  }
}

export default connect(state => state)(Ministries);



// WEBPACK FOOTER //
// ./src/components/desktop/Ministries.js